<template>
  <ion-item :detail="false" button class="list-item" @click="selectContainer">
    <template v-if="item">
      <ion-radio slot="start" :value="item"></ion-radio>
      <ion-thumbnail
        v-if="item.images.length > 0"
        slot="start"
      >
        <ApiImage
          v-if="item.images.length > 0"
          :style="{ display: imageLoaded }"
          :size="[LIST_IMAGE_THUMBNAIL_SIZE_PX, LIST_IMAGE_THUMBNAIL_SIZE_PX]"
          :uuid="item.images[0]"
          @ionImgDidLoad="imageLoaded = true"
        />
        <ApiIcon
          v-if="!imageLoaded && item.object.logo"
          class="app-icon"
          :type="item.object.logo.type"
          :name="item.object.logo.name"
          :iconStyle="item.object.logo.style"
        />
        <div
          v-else-if="!imageLoaded"
          class="missing"
        >
          image loading
        </div>
      </ion-thumbnail>
      <ion-thumbnail
        v-else
        slot="start"
      >
        <ApiIcon
          v-if="item.object.logo"
          class="app-icon"
          :type="item.object.logo.type"
          :name="item.object.logo.name"
          :iconStyle="item.object.logo.style"
        />
        <div
          v-else
          class="missing"
        >
          no image
        </div>
      </ion-thumbnail>
      <ion-label class="ion-text-wrap">
        <h2 class="no-wrap">
          {{ item.object.name }}
          <ion-note class="h2-note">id: {{ item.object.id }}</ion-note>
        </h2>
        <p v-if="item.object.description" class="no-wrap">
          {{ item.object.description.split('\n').join(' ') }}
        </p>
      </ion-label>
    </template>
    <ApiIcon v-else slot="start"></ApiIcon>
  </ion-item>
</template>

<script setup lang="ts">
import { IonItem, IonLabel, IonNote, IonRadio, IonThumbnail } from "@ionic/vue";
import { computed, ref } from "vue";
import { defineComponent } from "vue";
import type { ApiObjectWithReferences } from "@/models/api";
import ApiIcon from "@/components/ApiIcon.vue";
import ApiImage from "@/components/ApiImage.vue";
import { LIST_IMAGE_THUMBNAIL_SIZE_PX } from "@/components/constants";

defineComponent({
  name: "ChooseIconListElement",
});
const props = defineProps<{
  container: ApiObjectWithReferences | null;
}>();
const emit = defineEmits<{
  (e: "select", value: ApiObjectWithReferences): void;
}>();

const imageLoaded = ref(false);

const item = computed<ApiObjectWithReferences | null>(() => props.container );

function selectContainer() {
  if (item.value) {
    emit("select", item.value);
  }
}
</script>

<style scoped>
.no-wrap {
  white-space: nowrap; /* Prevent text from wrapping */
  overflow: hidden; /* Hide overflow text */
  text-overflow: ellipsis; /* Show ellipsis for overflow text */
}
.app-icon, .missing {
  width: 100%;
  height: 100%;
}
.missing {
  display: flex;
  justify-content: center; /* Center horizontally */
  align-items: center; /* Center vertically */
  text-align: center;
}
.h2-note {
  margin-left: .5em;
}
</style>
